import PlayerRouter from "./router/player-router";

export default [PlayerRouter];